import { PriceChangeRequest } from '../codegen/graphql';

export function getProductCurrency(
    request: PriceChangeRequest | null,
    fallbackCurrency: string = 'ZAR',
): string {
    const requestCurrency = request?.currency?.trim();
    if (requestCurrency) return requestCurrency;

    const sellingPriceCurrency = request?.product?.sellingPriceCurrency?.trim();
    if (sellingPriceCurrency) return sellingPriceCurrency;

    return fallbackCurrency;
}

export function getCurrencyFromRequest(
    request: {
        currentPriceCurrency?: string | null;
        proposedPriceCurrency?: string | null;
    } | null,
    fallbackCurrency: string = 'ZAR',
): string {
    return (
        request?.proposedPriceCurrency?.trim() ||
        request?.currentPriceCurrency?.trim() ||
        fallbackCurrency
    );
}
